/* eslint-disable max-len */
import * as React from 'react';

type SvgIconProps = {
  className: string,
}

function SvgIcon({
  className,
}: SvgIconProps) {
  return (
    <svg
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 -1 26 26"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m25.199 21.599h-9.103l9.952-9.952c.217-.217.351-.517.351-.848s-.134-.631-.351-.848l-9.6-9.6c-.217-.217-.517-.351-.848-.351s-.631.134-.848.351l-14.401 14.399c-.217.217-.351.517-.351.848s.134.631.351.848l7.2 7.203c.217.217.517.351.848.351h16.8.034c.663 0 1.2-.537 1.2-1.2s-.537-1.2-1.2-1.2c-.012 0-.024 0-.035.001h.002zm-9.599-18.703 7.903 7.903-6.943 6.943-7.903-7.903z"
      />
    </svg>
  );
}

export default SvgIcon;
